const DRIVER_FORM_KEY = "vendor_add_driver_form_draft";
const DRIVER_FRESH_FLAG_KEY = "vendor_add_driver_fresh_flag";

export interface DriverFormDraft {
  driverName: string;
  email: string;
  mobileNumber: string;
  drivingLicense: string;
  address: string;
  // Note: Files cannot be persisted, so we exclude them
}

export const saveDriverDraft = (data: Partial<DriverFormDraft>): void => {
  try {
    // Exclude file fields as they cannot be serialized
    const { dlFile, profilePicture, ...serializableData } = data as any;
    localStorage.setItem(DRIVER_FORM_KEY, JSON.stringify(serializableData));
  } catch (error) {
    console.error("Failed to save driver form draft:", error);
  }
};

export const loadDriverDraft = (): DriverFormDraft | null => {
  try {
    const raw = localStorage.getItem(DRIVER_FORM_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error("Failed to load driver form draft:", error);
    return null;
  }
};

export const clearDriverDraft = (): void => {
  localStorage.removeItem(DRIVER_FORM_KEY);
};

export const markDriverFreshStart = (): void => {
  localStorage.setItem(DRIVER_FRESH_FLAG_KEY, "true");
};

export const clearDriverFreshFlag = (): void => {
  localStorage.removeItem(DRIVER_FRESH_FLAG_KEY);
};

export const isDriverFreshStart = (): boolean => {
  return localStorage.getItem(DRIVER_FRESH_FLAG_KEY) === "true";
};

